module.exports = __webpack_public_path__ + "img/benoit11.804104be.jpg";